import { useDispatch, useSelector } from 'react-redux';
import constants from '../../constants';
import { getRouteObjByGame, isMatchInScheduled } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import { useLink } from 'react-router-stack';
import useGame from '../../utilities/hooks/game';
import View from '../view';
import Constants from '../../constants';
import { CounterWrapper } from '../header_with_timer';
import Text from '../text';

const FantasyHeader = ({ matchItem, onCalledDeadline, gameType }: any) => {
  const { ComponentTheme } = useTheme();
  const dispatch = useDispatch();
  const { myTeamList: fantasyCricketMyTeamsList } = useSelector(
    (state: any) => state.fantasy_cricket
  );
  const { myTeamList: fantasyFootballMyTeamsList } = useSelector(
    (state: any) => state.fantasy_football
  );
  const {
    teamA = {},
    teamB = {},
    status: matchStatus,
    verified,
    gameState = 0,
    matchDelayed = false
  } = matchItem;

  const matchTitleTextColor = {
    color: ComponentTheme.headerTitle
  };
  const navigate = useLink();

  const isMatchScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });
  const totalTeamsCount =
    gameType === constants.GameType.FANTASY_CRICKET
      ? fantasyCricketMyTeamsList[matchItem['_id']]?.length
      : gameType === constants.GameType.FANTASY_FOOTBALL
      ? fantasyFootballMyTeamsList[matchItem['_id']]?.length
      : 0;
  const { fantasyMatchClick } = useGame();
  const timerIconDimension = '20px';
  const onPressCreateTeam = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          isFromCreateTeamButton: true,
          selectedTeamPlayers: [],
          teamData: {
            teamNumber: totalTeamsCount + 1
          },
          isEdit: false,
          isClone: false
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['create_team'], {
      teamData: {
        teamNumber: totalTeamsCount + 1
      }
    });
  };

  return (
    <>
      <div className="fantasy-cricket-header-with-timer-wrapper">
        <View className="fantasy_cricket_header_timer_wrapper">
          {isMatchScheduled && (
            <View className="header-with-timer-icon-wrapper">
              <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
            </View>
          )}
          {
            <CounterWrapper
              onCalledDeadline={onCalledDeadline}
              matchStatus={matchStatus}
              verified={verified}
              matchItem={matchItem}
              isMatchScheduled={isMatchScheduled}
              gameType={gameType}
            />
          }
        </View>
        {/* {!onlyTimer && ( */}

        <Text style={matchTitleTextColor} className="fantasy-cricketheader-with-timer-title">
          {`${teamA?.name} vs  ${teamB?.name}`}
        </Text>

        {/* )} */}
        <button className="create-team-btn" onClick={onPressCreateTeam}>
          Create Team
        </button>
      </div>
    </>
  );
};

export default FantasyHeader;
